export default {
  // General
  'About {appName}': 'О {appName}',
  'About Enable Banking API': 'О Enable Banking API',
  'Application description is not provided.': 'Описание приложения не предоставлено.',
  'Authenticate': 'Аутентифицироваться',
  'Authentication method': 'Метод аутентификации',
  'Authentication session has expired': 'Сеанс аутентификации истек',
  'Cancel': 'Отмена',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Нажмите кнопку {0}, если вы подтвердили авторизацию в приложении BankID.',
  'Continue authentication': 'Продолжить аутентификацию',
  'Cookies must be enabled in your browser to continue': 'Для продолжения необходимо включить файлы cookie в браузере',
  'Enter your OTP code with index {0}': 'Введите ваш OTP-код с индексом {0}',
  'Error during authentication:': 'Ошибка при аутентификации:',
  'Error while updating authentication status': 'Ошибка при обновлении статуса аутентификации',
  'OTP code': '',
  'Open the BankID app on this device': 'Открыть приложение BankID на этом устройстве',
  'Redirecting to your account servicing provider': 'Перенаправление к провайдеру, обслуживающему ваш счет',
  'Returning to the authentication initiator': 'Возвращение к инициатору аутентификации',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Запустите приложение BankID на вашем мобильном устройстве, нажмите кнопку QR-кода и отсканируйте QR-код с этой страницы.',
  'or': 'или',
  'Starting authorization': 'Запуск авторизации',
  'To continue please use your authentication app': 'Чтобы продолжить, используйте приложение для аутентификации',
  'Try again': 'Попробовать еще раз',
  'Submit': 'Отправить',
  'Unable to access server': 'Невозможно получить доступ к серверу',
  'Unable to authenticate': 'Невозможно аутентифицировать',
  'Unable to continue authorization': 'Невозможно продолжить авторизацию',
  'Unable to continue decoupled authorization': 'Невозможно продолжить несвязанную авторизацию',
  'Unable to handle authentication status "{status}"': 'Невозможно обработать статус аутентификации "{status}"',
  'Unknown error occurred': 'Произошла неизвестная ошибка',
  'You need to close this window': 'Вам нужно закрыть это окно',
  'Authentication cancelled': 'Аутентификация отменена',
  // Consent
  'Authentication is initiated by {0}.': 'Аутентификация инициирована {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'После завершения аутентификации {0} будут переданы инициатору аутентификации.',
  'your payment accounts data': 'данные ваших платежных счетов',
  'the list of your payment accounts': 'список ваших платежных счетов',
  'the list of your payment accounts and accounts balances': 'список ваших платежных счетов и остатки на счетах',
  'the list of your payment accounts and accounts transactions': 'список ваших платежных счетов и транзакции по счетам',
  'the list of your payment accounts, accounts balances and transactions': 'список ваших платежных счетов, остатки на счетах и транзакции',
  'By pressing {0} button you agree with the {1}.': 'Нажимая кнопку {0}, вы соглашаетесь с {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Нажмите кнопку {0}, если вы не хотите предоставлять данные своих платежных счетов.',
  // Payment consent
  'Payment details': 'Детали платежа',
  'Payment ID provided by the application: {0}': 'Идентификатор платежа, предоставленный приложением: {0}',
  'Account number where to transfer funds: {0}': 'Номер счета для перевода средств: {0}',
  'Payee name in the payment: {0}': 'Имя получателя платежа: {0}',
  'Payee country: {0}': 'Страна получателя: {0}',
  'Payment amount: {0}': 'Сумма платежа: {0}',
  'Message or reference number in the payment: {0}': 'Сообщение или номер в платеже: {0}',
  'Payment is initiated by {0}.': 'Платеж инициирован {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'После того, как вы завершите аутентификацию, ваше согласие на оплату будет запрошено поставщиком платежных услуг, обслуживающим вашу учетную запись.',
  'terms of service': 'условия использования',
  'Press {0} button if you are not willing to complete this payment.': 'Нажмите кнопку {0}, если вы не хотите совершать этот платеж.',
  'Select Payment Account': 'Выберите платежный счет',
  'Confirm': 'Подтвердить',
  // Backend messages
  '10 digit client number': '10-значный номер клиента',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10-значный номер организации (или 12-значный личный номер, если компания является индивидуальным предпринимателем)',
  '10 digit organization number.': '10-значный номер организации.',
  '17 digit card number (starting with 6703)': '17-значный номер карты (начиная с 6703)',
  '6 digit Handelsbanken customer number': '6-значный номер клиента Handelsbanken',
  '8 digits CVR number': '8-значный CVR-номер',
  '9 digits Organisasjonsnummer': '9-значный Organisasjonsnummer',
  'Agreement number': 'Номер договора',
  'Agreement number for Nordea Corporate Netbank': 'Номер договора для корпоративного интернет-банка Nordea',
  'Bank user ID': 'Идентификатор пользователя банка',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Идентификационный код предприятия (Y-tunnus) в формате 1234567-8.',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Идентификационный код компании, который отображается в настройках Корпоративного интернет-банка',
  'Client ID': 'ID клиента',
  'Client number': 'Номер клиента',
  'Company ID': 'Идентификатор компании',
  'Company number': 'номер компании',
  'Corporate ID': 'Корпоративный идентификатор',
  'Corporate registration ID': 'Корпоративный регистрационный ID',
  'Currency code': 'Код валюты',
  'Digit card number': 'цифровой номер карты',
  'Disposer': 'Диспоузер',
  'E-mail': 'Электронная почта',
  'E-mail used for authenticating to Holvi': 'Электронная почта, используемая для аутентификации в Holvi',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Либо 14-значный идентификатор SEB для компании, либо 10-значный номер организации.',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (без номера субсчета): 3-значный номер отделения + 7-значный номер клиента',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'Для шведских корпораций это их номер организации или номер SHB, а для индивидуальных предпринимателей (Enskild firma) это их личный номер, все из которых состоят из 10 цифр.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, паспорт',
  'Login ID used in MyBRD aplications': 'Идентификатор входа, используемый в приложениях MyBRD',
  'Login Name': 'Логин',
  'Mandate ID': 'Идентификатор мандата',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Норвежский национальный идентификационный номер в формате DDMMYYXXXXX (11 цифр)',
  'Online banking PIN': 'PIN-код онлайн-банкинга',
  'Online banking Password': 'Пароль онлайн-банкинга',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Идентификатор организации в формате TBxxxxx или TXxxxxxx',
  'Organisation number': 'Номер организации',
  'PIN': 'ПИН',
  'Password': 'Пароль',
  'Password for Aktia Internet bank': 'Пароль для интернет-банка Актиа',
  'Password used for authenticating to Holvi': 'Пароль, используемый для аутентификации в Holvi',
  'Personal ID': 'Персональный идентификационный номер',
  'Personal ID number': 'Личный идентификационный номер',
  'Personal code': 'Персональный код',
  'Personal code of the user': 'Персональный код пользователя',
  'Personal signatory number': 'Личный номер подписи',
  'Personal username for online banking': 'Личное имя пользователя для онлайн-банкинга',
  'Postbank ID': 'Идентификатор почтового банка',
  'Social security number (Personnummer)': 'Номер социального страхования (номер лица)',
  'Social security number in the format YYYYMMDDXXXX': 'Номер социального страхования в формате YYYYMMDDXXXX.',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Шведский номер социального страхования в формате YYYYMMDDXXXX.',
  'The IBAN of the user authenticating': 'IBAN пользователя, аутентифицирующего',
  'The currency code': 'Код валюты',
  'The user ID of the user authenticating': 'Идентификатор пользователя, аутентифицирующего',
  'Unique personal ID number': 'Уникальный персональный идентификационный номер',
  'User ID': 'ID пользователя',
  'User ID for Aktia Internet bank': 'Идентификатор пользователя для интернет-банка Aktia',
  'User ID for Nordea Corporate Netbank': 'Идентификатор пользователя для корпоративного интернет-банка Nordea',
  'User ID for online banking': 'Идентификатор пользователя для онлайн-банкинга',
  'User ID in the format XX000000': 'ID пользователя в формате XX000000',
  'User ID used to log in to the bank': 'Идентификатор пользователя, используемый для входа в банк',
  'Username': 'имя пользователя',
  'Username used to log in to the bank': 'Имя пользователя, используемое для входа в банк',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'Имя пользователя WebSSO',
}
